function AddEntry() {
	const AddEntryButton = jQuery( '.gpnf-add-entry' );
	AddEntryButton.addClass( 'btn btn-primary' )
}

	export default {
		init() {
			AddEntry();
		},
	};
